import api from '../../api/index.js'

const state = {
    
}

const getters = {

}

const actions = {
    AddFeedBack({commit},payload) {
        return new Promise((resolve, reject) => {
            api.post('/FeedBack/Post',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/feedback.js